import { frontendURL } from '../../../helper/URLHelper';

const HomePage = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/home'),
    name: 'home_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: HomePage,
  },
];
